export default __webpack_public_path__ + "static/media/iphone-11.4456e221.png";